export default angular.module("mars.vet.dnareports.controllers.mixedcomponent", []).controller('MixedComponentController',
    function($rootScope, $scope, $routeParams, $window, BreedListService, NavigationService, EntryService, EntryIDService, ImageService, reportdata) {
        'ngInject';

        let sampleDetails = reportdata.sampleDetails;
        let resultString = reportdata.resultString;
        $scope.mixBreedFlag = "false";
        $scope.breedList = BreedListService.getSortedBreedList();

        angular.forEach($scope.breedList, function(result, key) {
            if (result['breed'] == 'Mixed Breed Groups') {
                $scope.mixBreedFlag = "true";
            }
        });

        if ($scope.mixBreedFlag != 'false') {

            var reportType = 'online';
            $scope.onloadFun = function() {
                reportType = 'pdf';
            }

            EntryService.getEntry(EntryIDService.getEntryID('Mixed Breed Groups')).then(function(response) {
                var fields = response.fields;

                $scope.subTitle = "What does Mixed-breed or “Groups” mean for " + sampleDetails.petDetails.petName + "?";
                $scope.description = fields.description.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);

                var breedList = BreedListService.getBreedList();
                $scope.count = breedList['Mixed Breed Groups'];
                if (reportType != 'pdf') {
                    $rootScope.pageTitle = fields.title + ' - ' + ((breedList['Mixed Breed Groups'] * 100) / 8) + '%';
                }
                $scope.title = fields.title + ' - ' + ((breedList['Mixed Breed Groups'] * 100) / 8) + '%';
                NavigationService.setNavigationUrls();
                $window.ga('send', 'pageview', {
                    'page': 'Mixed Component'
                });

            }, function(error) {
                // promise rejected, could log the error with:
                // console.log('error', error);
            });
            //
            // Retrieve group images and description from contentful
            //
            var next5BreedGroupList = [];

            EntryService.getEntry(EntryIDService.getEntryID('Breed Group Mappings')).then(function(response) {

                var breedGroups = response.fields.breedGroups;

                angular.forEach(resultString.next5, function(value, key) {
                    var carouselArray = [];
                    angular.forEach(breedGroups[value]['carouselImages'], function(value, key) {
                        if (value !== null && value != "") {
                            carouselArray.push(value);
                        }
                    });
                    next5BreedGroupList.push({
                        'GroupName': value,
                        'Description': breedGroups[value]['description'],
                        'GroupImages': carouselArray,
                        'GroupBreeds': breedGroups[value]['carouselBreeds'],
                        'groupIcon': breedGroups[value]['groupIcon']
                    });
                });
                angular.forEach(resultString.next5, function(value, key) {
                    ImageService.getImageUrl(breedGroups[value]['groupIcon']).then(function(response) {
                        if (response.data.fields.file.url !== undefined) {
                            angular.forEach(next5BreedGroupList, function(value, key) {
                                if (breedGroups[value['GroupName']]['groupIcon'] == response.data.sys.id) {
                                    value['GroupIcon'] = response.data.fields.file.url
                                }
                            });
                        }
                    });
                });
                $scope.next5BreedGroups = next5BreedGroupList;
            });
        }
    }).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/mixedcomponent.controller.js